import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/core/services/api.service';
import { CustomFieldServiceService } from 'app/core/services/custom-field.service';
import { MappingService } from 'app/core/services/mapping.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
    selector: 'custom-field',
    templateUrl: './custom-field.component.html',
    styleUrls: [],
})
export class CustomFieldComponent implements OnInit {
    isAddField: boolean = false;
    isUpdateField: boolean = false;
    @Input() activaPage: 'prospect_field' | 'sequence' | 'template' | 'integration' = 'prospect_field';
    @ViewChild('focusInput') focusInput: ElementRef;
    constructor(
        private _api: ApiService,
        private _mapping: MappingService,
        private _util: UtilService,
        private _dialog: MatDialog,
        public _customFieldSer: CustomFieldServiceService
    ) {}

    ngOnInit(): void {
      
    }

    

    addCustomField() {
        console.log('beforeAdd Custom field', this._customFieldSer.customField);
        Object.entries(this._customFieldSer.form).forEach(([key, value]) => {
            this._customFieldSer.form[key].markAsDirty();
            this._customFieldSer.form[key].markAsTouched();
        });

        if (this._customFieldSer.customFieldForm.invalid || this.isAddField) return;
        this.isAddField = true;
        const fd = new FormData();
        fd.append('field_name', this._customFieldSer.form.name.value);
        fd.append(
            'is_visible',
            this._customFieldSer.form.isVisible.value == 'visible' ? '1' : '0'
        );
        fd.append(
            'fallback',
            this._customFieldSer.form.fallbackText.value == null ||
            this._customFieldSer.form.fallbackText.value == ''
                ? ''
                : this._customFieldSer.form.fallbackText.value
        );
        this._api.postData('add-custom-field', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    if(this.activaPage == 'prospect_field') {
                        this._customFieldSer.backupFields.unshift(res.data);
                        this._customFieldSer.customField.unshift(res.data);
                        this._customFieldSer.backupFields.length;
                        this._customFieldSer.allFields.data = Object.assign([], this._customFieldSer.backupFields);
                        this._customFieldSer.updatePagination(this._customFieldSer.allFields)
                    }
                    if (res.data.is_visible != 0) {
                        this._mapping.customFields.custom.unshift(res.data);
                    }
                    this._mapping.mappingField.unshift(res.data);
                    if(this.activaPage == 'integration') {
                        this._customFieldSer.allMappingKeys.unshift(res.data);
                        this._customFieldSer.notSelectedMapping.unshift(res.data);
                    }
                    this._util.showToast(res.message);
                    this._dialog.closeAll();
                    console.log('after add Custom field', this._customFieldSer.customField, this._customFieldSer.allFields);
                } else {
                    this._util.showToast(res.message, true);
                }
                this.isAddField = false;
            },
            error: (err) => {
                console.log('err', err);
                this.isAddField = false;
                if(err instanceof Object) {
                    Object.entries(err).forEach(([key, value]) => {
                      switch(key) {
                        case 'field_name': 
                        this._customFieldSer.customFieldForm.controls['name'].setErrors({
                          lv: value[0],
                        });
                        break;
                        case 'is_visible': 
                        this._customFieldSer.customFieldForm.controls['isVisible'].setErrors({
                            lv: value[0],
                          });
                        break;
                        case 'fallback': 
                        this._customFieldSer.customFieldForm.controls['fallbackText'].setErrors({
                            lv: value[0],
                          });
                      }
                    })
                  }
            },
            complete() {},
        });
    }

    updateCustomField() {
        Object.entries(this._customFieldSer.form).forEach(([key, value]) => {
            this._customFieldSer.form[key].markAsDirty();
            this._customFieldSer.form[key].markAsTouched();
        });
        if (this._customFieldSer.customFieldForm.invalid || this.isUpdateField) return;
        this.isUpdateField = true;
        const fd = new FormData();
        fd.append('field_id', this._customFieldSer.updateField.id);
        fd.append(
            'is_visible',
            this._customFieldSer.form.isVisible.value == 'visible' ? '1' : '0'
        );
        fd.append(
            'fallback',
            this._customFieldSer.form.fallbackText.value == null ||
            this._customFieldSer.form.fallbackText.value == ''
                ? ''
                : this._customFieldSer.form.fallbackText.value
        );
        this._api.postData('update-custom-field', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this._customFieldSer.allFields.data.forEach((field) => {
                        if (field.id == this._customFieldSer.updateField.id) {
                            field.is_visible =
                            this._customFieldSer.form.isVisible.value == 'visible'
                                    ? '1'
                                    : '0';
                            field.fallback = this._customFieldSer.form.fallbackText.value;
                            if (this._customFieldSer.activeTabInd == 0) {
                                if (field.is_visible == '1') {
                                    this._mapping.customFields.custom.push(
                                        field
                                    );
                                } else {
                                    this._mapping.customFields.custom.forEach(
                                        (custom, ind) => {
                                            if (
                                                custom.id == this._customFieldSer.updateField.id
                                            ) {
                                                this._mapping.customFields.custom.splice(
                                                    ind,
                                                    1
                                                );
                                            }
                                        }
                                    );
                                }
                            } else if (this._customFieldSer.activeTabInd == 1) {
                                if (field.is_visible == '1') {
                                    this._mapping.customFields.system.push(
                                        field
                                    );
                                } else {
                                    this._mapping.customFields.system.forEach(
                                        (custom, ind) => {
                                            if (
                                                custom.id == this._customFieldSer.updateField.id
                                            ) {
                                                this._mapping.customFields.system.splice(
                                                    ind,
                                                    1
                                                );
                                            }
                                        }
                                    );
                                }
                            }
                        }
                    });
                    this._util.showToast(res.message);
                    this._dialog.closeAll();
                } else {
                    this._util.showToast(res.message, true);
                }
                this.isUpdateField = false;
            },
            error: (err) => {
                console.log('err', err);
                this.isUpdateField = false;
                if(err instanceof Object) {
                    Object.entries(err).forEach(([key, value]) => {
                      switch(key) {
                        case 'field_name': 
                        this._customFieldSer.customFieldForm.controls['name'].setErrors({
                          lv: value[0],
                        });
                        break;
                        case 'is_visible': 
                        this._customFieldSer.customFieldForm.controls['isVisible'].setErrors({
                            lv: value[0],
                          });
                        break;
                        case 'fallback': 
                        this._customFieldSer.customFieldForm.controls['fallbackText'].setErrors({
                            lv: value[0],
                          });
                      }
                    })
                  }
            },
            complete() {},
        });
    }
}
